import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type {
  ServiceResponse,
  UserDB,
  FinalizeSignupResponse,
 //   UserVoteInfo,
 //   UserVotesResponse
} from '@dopomogai/types';


// The payload for updating a user will be a partial object
type UserUpdatePayload = Partial<Pick<UserDB, 'name'>>;

export const userService = {
  /**
   * Retrieves the full profile for the authenticated user.
   */
  getProfile: (): ServiceResponse<UserDB> => {
    return getApiClient().get<UserDB>('/users/me')
      .then(res => res.data)
      .catch(err => handleApiError(err, 'fetching user profile'));
  },
  
  /**
   * Allows the authenticated user to update their profile information.
   */
  updateProfile: (payload: UserUpdatePayload): ServiceResponse<UserDB> => {
    return getApiClient().patch<UserDB>('/users/me', payload)
      .then(res => res.data)
      .catch(err => handleApiError(err, 'updating user profile'));
  }

};